<template>
  <div class="boss">
    <div class="reading">
      <div v-if="safari == false">
        <div
          style="
            height: 136px;
            overflow: hidden;
            width: 100%;
            background-size: 100%;
            background-image: url(http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/06/1622700970029.png);
            background-repeat: no-repeat;
          "
        >
          <div
            style="
              text-align: center;

              color: white;
            "
          >
            <p style="font-size: 16px; padding-top: 32px">考试名称：</p>
            <div style="font-size: 18px; padding-top: 20px; line-height: 30px">
              {{ exam_name }}
            </div>
          </div>
        </div>
        <div class="reading-main">
          <div></div>
          <div class="reading-detail" v-if="timelimit == true">
            <div style="margin-top: 40px; color: #999999; font-size: 16px">
              考试时间:
            </div>
            <div style="margin-top: 16px; font-size: 18px">
              {{ begin_time }}
            </div>

            <div style="margin-top: 12px; color: #999999; font-size: 16px">
              至
            </div>

            <div style="margin-top: 12px; font-size: 18px">{{ end_time }}</div>
          </div>
          <div class="reading-name">
            <div
              style="
                font-size: 16px;
                margin-top: 24px;
                color: #999999;
                padding-top: 24px;
              "
            >
              考生姓名:
            </div>
            <div
              style="
                font-size: 24px;
                font-weight: bold;
                color: black;
                margin-top: 24px;
              "
            >
              {{ student_name }}
            </div>
          </div>
          <div style="font-size:0.7rem;color:red;padding: 0.8rem 0 0;line-height: 1rem;">
            <template v-if="!ios">安卓系统请使用微信信内嵌浏览器/Chrome浏览器，因为版权限制，华为手机不支持此功能。</template>
            <template v-else>苹果手机系统版本要求14.3以上，请使用微信信内嵌浏览器/Chrome浏览器。</template>
            <a href="https://cloud.tencent.com/document/product/647/17249" style="color:rgb(45, 103, 255);text-decoration: underline">查看支持的平台</a></div>
          <div class="reading-footer" v-show="device_flag == true">
            <van-button @click="device_test">
              {{ "设备检测" }}
            </van-button>
          </div>
          <div class="reading-footer" v-show="device_flag == false">
            <van-button @click="device_test">
              {{ "进入监控" }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="safari == true" style="min-height: 100%; position: relative">
      <div
        style="
          margin-top: 25px;
          float: right;
          margin-right: 36px;
          width: 197px;
          height: 44px;
          font-size: 14px;
          position: relative;
          display: flex;
        "
      >
        <div style="color: #737386">
          为保证考试效果，点击右上角选择在
          <img
            src="../../../assets/images/exam_live/safari_icon.png"
            style="width: 25px; height: 25px"
          />
          浏览器中打开
        </div>
        <div style="margin-top: -20px; float: right; margin-right: -13px">
          <img
            src="../../../assets/images/exam_live/jian.png"
            style="width: 26px; height: 52px"
          />
        </div>
      </div>

      <div
        style="
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 200px;
          background-image: url(http://hrss-tes.oss-cn-beijing.aliyuncs.com/hrss/image/2021/06/1624425560907.png);
        "
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeviceCheck",
  data() {
    return {
      device_flag: true,
      contaArray: [],
      exam_name: "",
      begin_time: "",
      end_time: "",
      student_name: "",
      stopClickLogin: false,
      maxtime: 5,
      Check: false,
      readingtext: "考试时间",
      chooseImg: require("../../../assets/images/exam_live/notchoose.png"),
      radio: false,
      timelimit: true,
      weixin: false,
      ios: false,
      safari: false,
    };
  },
  async created() {
    this.isIOS();
    this.WeiXin();
    if (this.weixin == true && this.ios == true) this.safari = true;
    //  let pa = { token: "387c872d6caa49d1b398945f80645795" };
    localStorage.setItem("organ", "");
    localStorage.setItem("actor", "");
    localStorage.setItem("token", "");
    localStorage.setItem("branch", "");
    localStorage.setItem("tokens", this.$route.query.tokens);

    let pa = { token: this.$route.query.tokens };
    var container;
    await this.$api.exam_live.getInfo(pa).then((res) => {
      if (res.message == "success") {
        container = res.data;
      }
    });
    let flag = 0;
    for (let i = 0; i < container.length; i++) {
      if (container[i] == "&") {
        if (flag == 0) {
          this.contaArray.push(container.substring(flag, i));
        } else this.contaArray.push(container.substring(flag + 2, i));
        flag = i;
      }
    }
    this.contaArray.push(container.substring(flag + 2, container.length));
    localStorage.setItem("organ", this.contaArray[3]);
    localStorage.setItem("actor", this.contaArray[4]);
    localStorage.setItem("token", this.contaArray[5]);
    localStorage.setItem("branch", this.contaArray[6]);
    if (this.contaArray[7] != null && this.contaArray[7] != undefined) {
      sessionStorage.setItem("userpaperid", this.contaArray[7]);
      this.device_flag = false;
    }
    await this.$api.exam_live
      .getExam({ id: this.contaArray[0] })
      .then((res1) => {
        if (res1.message == "success") {
          container = res1.data;
          this.exam_name = container.name;
          this.student_name = container.userName;
          this.begin_time = container.startTime;
          this.end_time = container.endTime;
          sessionStorage.setItem("examname", this.exam_name);

          if (container.isLimitTime == 0) this.timelimit = false;
        }
      });
  },
  beforeMount() {
    // 修改背景色
    if (this.safari == false) {
      document
        .querySelector("body")
        .setAttribute("style", "background-color: #f5f6fa;padding: 15px;");
    }
  },
  beforeDestroy() {
    // 销毁背景色
    document.querySelector("body").removeAttribute("style");
  },

  mounted() {},
  methods: {
    isIOS() {
      // 判断是iOS 还是安卓
      let u = navigator.userAgent;
      let app = navigator.appVersion;
      // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        this.ios = true;
      }
    },
    WeiXin() {
      // 判断是否是微信内置浏览器
      let isWeiXin = () => {
        return (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        );
      };
      if (isWeiXin()) {
        this.weixin = true;
      }
    },
    device_test() {
      sessionStorage.setItem("channel", 2);
      sessionStorage.setItem("tasktype", this.contaArray[1]);
      sessionStorage.setItem("examid", this.contaArray[0]);
      sessionStorage.setItem("businessid", this.contaArray[2]);

      this.$router.push("/supervise_test");
    },
  },
};
</script>
<style lang='stylus'>
#wdc-app {
  border-radius: 12px;
}

.boss {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
}

.reading {
  &-detail {
    text-align: center;
    margin-top: 40px;
  }

  .van-button {
    width: 100%;
    height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    background-color: #316fff;
    color: #ffffff;
    line-height: 22px;
    margin-top: 50px;
  }

  &-name {
    text-align: center;
    height: 200px;
    border-radius: 8px;
    background-color: #F5F6FA;
    margin-top: 100px;
  }

  &-main {
    border-radius: 12px;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 25px;
  }

  &-title {
    text-align: center;
    z-index: 1;

    .d {
      z-index: 4;
    }
  }
}
</style>
<style scoped>
</style>